export default __webpack_public_path__ + "d826378eb64ab92b739c145f0263b75f.png";